import React, { useState, useEffect } from 'react';
import './PenaltiesCharges.css';
import Layout from '../../../../components/Layout';
import { Box, Typography } from '@mui/material';
import AdminNavbar from '../../../../components/Admin/AdminNavbar/AdminNavbar';
import { axiosInstance } from '../../../../utils/tokenUtils';
import toast from 'react-hot-toast';
// import Student from "../../../../components/Admin/FeeSettings/PenaltiesCharges/StudentAccordian";
import Teacher from '../../../../components/Admin/FeeSettings/PenaltiesCharges/TeacherAccordian';

// export const studentData = [
//   {
//     name: 'High School',
//     sessions: [
//       { type: 'One-One-Session', deduction: 20 },
//       { type: 'Group Session', deduction: 10 },
//       { type: 'Prime Session', deduction: 12 },
//     ],
//   },
//   {
//     name: 'Middle School',
//     sessions: [
//       { type: 'One-One-Session', deduction: 20 },
//       { type: 'Group Session', deduction: 10 },
//       { type: 'Prime Session', deduction: 12 },
//     ],
//   },
//   {
//     name: 'University',
//     sessions: [
//       { type: 'One-One-Session', deduction: 20 },
//       { type: 'Group Session', deduction: 10 },
//       { type: 'Prime Session', deduction: 12 },
//     ],
//   },
// ];

// export const teacherData = [
//   {
//     name: 'High School',
//     sessions: [
//       { type: 'One-One-Session', deduction: 20 },
//       { type: 'Group Session', deduction: 10 },
//       { type: 'Prime Session', deduction: 12 },
//     ],
//   },
//   {
//     name: 'Middle School',
//     sessions: [
//       { type: 'One-One-Session', deduction: 20 },
//       { type: 'Group Session', deduction: 10 },
//       { type: 'Prime Session', deduction: 12 },
//     ],
//   },
//   {
//     name: 'University',
//     sessions: [
//       { type: 'One-One-Session', deduction: 20 },
//       { type: 'Group Session', deduction: 10 },
//       { type: 'Prime Session', deduction: 12 },
//     ],
//   },
// ];

const PenaltiesCharges = () => {
  const [rbacMe, setRbacMe] = useState(null);

  // Helper function to check if user has a specific permission
  const hasPermission = permission => {
    if (!rbacMe || !Array.isArray(rbacMe.permissions)) return false;
    return rbacMe.permissions.includes(permission);
  };

  // Check if current user can manage fee settings
  const canManageFeeSettings = () => {
    return hasPermission('manage_fee_settings') || (rbacMe?.roles || []).includes('super_admin');
  };

  // Load current user permissions
  useEffect(() => {
    const fetchCurrentUser = async () => {
      try {
        let cachedData = null;
        try {
          const cached = sessionStorage.getItem('rbac_admin_me');
          if (cached) {
            cachedData = JSON.parse(cached);
            setRbacMe(cachedData);
          }
        } catch (_) {}

        const { data } = await axiosInstance.get('/admin/rbac/admin/me');
        setRbacMe(data);

        try {
          sessionStorage.setItem('rbac_admin_me', JSON.stringify(data));
        } catch (_) {}
      } catch (_) {
        if (!rbacMe) setRbacMe({ roles: [], permissions: [] });
      }
    };

    fetchCurrentUser();
  }, []);

  return (
    <Layout title="Klass Online | Penalties Charges">
      <Box className="relative h-screen w-full overflow-hidden">
        <Box className="sticky top-0 left-0 right-0 z-[1000] bg-white pr-[10px]">
          <AdminNavbar />
        </Box>
        <Box className="h-[calc(100vh-64px)] overflow-auto relative bg-[#F9F9F9] rounded-lg mr-[10px]">
          <Box className="flex flex-col p-[1rem] gap-3">
            <Box className="flex justify-between items-center">
              <Typography className="penalties-charges-title">Penalties Charges</Typography>
            </Box>

            {/* Refund Policy Note */}
            <Box
              sx={{
                backgroundColor: '#fff3cd',
                border: '1px solid #ffeaa7',
                borderRadius: '8px',
                padding: '16px',
                marginBottom: '16px',
              }}
            >
              <Typography
                sx={{
                  fontSize: '14px',
                  color: '#856404',
                  fontFamily: 'Poppins',
                  fontWeight: 400,
                  lineHeight: '1.5',
                  margin: 0,
                }}
              >
                <strong>Refund Policy:</strong> The penalty amounts specified below will be deducted
                from instructor's balance when bookings are canceled within 8 hours of the scheduled
                session time. For cancellations made more than 8 hours after the scheduled time, no
                refund will be processed to the instructor.
              </Typography>
            </Box>

            <Teacher canManageFeeSettings={canManageFeeSettings} />
          </Box>
        </Box>
      </Box>
    </Layout>
  );
};

export default PenaltiesCharges;
